function removeDuplicatesInArray<T extends Array<T>>(arr: T, key: string): T[] {
  return Array.from(
    arr
      .reduce((map: any, each: any) => map.set(each[key], each), new Map())
      .values(),
  );
}

export { removeDuplicatesInArray };
